import React from "react";
import cx from "./cx";

const HELP_TONE_CLASS = { warn: 'rev-help--warn', err: 'rev-help--err' };

/**
 * Campo de formulario: etiqueta + control (children) + ayuda + error.
 *  - label: texto de la etiqueta; con htmlFor se pinta <label>, si no <span>
 *  - help / helpTone ('warn' | 'err'): texto .rev-help bajo el control
 *  - error: mensaje .rev-error con role="alert"
 * Los children se colocan entre la etiqueta y la ayuda, como en el artboard.
 */
const RevField = ({ label, htmlFor, help, helpTone, error, className, children, ...rest }) => {
    const LabelAs = htmlFor ? 'label' : 'span';
    return (
        <div className={cx('rev-field', className)} {...rest}>
            {label !== undefined && label !== null &&
                <LabelAs className="rev-label" htmlFor={htmlFor}>{label}</LabelAs>}
            {children}
            {help && <span className={cx('rev-help', HELP_TONE_CLASS[helpTone])}>{help}</span>}
            {error && <span className="rev-error" role="alert">{error}</span>}
        </div>
    );
};

export default RevField;
